import { render, staticRenderFns } from "./StockviewTabs.vue?vue&type=template&id=d30b1e52&"
import script from "./StockviewTabs.vue?vue&type=script&lang=js&"
export * from "./StockviewTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports